import { Modal } from './Modal';
import { ModalHeader } from './ModalHeader';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';
import { ModalWithButton } from './ModalWithButton';
import { ModalCard } from './ModalCard';
import { ModalTitle } from './ModalTitle';
export { Modal as default, Modal, ModalBody, ModalCard, ModalFooter, ModalHeader, ModalWithButton, ModalTitle };
//# sourceMappingURL=index.js.map